import { cn } from "@/lib/utils";

const TABS = [
  { id: "account", label: "Account" },
  { id: "heroes", label: "Heroes" },
  { id: "inventory", label: "Inventory" },
  { id: "costumes", label: "Costumes" },
  { id: "mail", label: "Mail" },
  { id: "sidecontents", label: "Side Contents" },
  { id: "raw", label: "Raw" },
] as const;

export type TabId = (typeof TABS)[number]["id"];

interface TabPanelProps {
  activeTab: TabId;
  onTabChange: (tab: TabId) => void;
  children?: React.ReactNode;
  hideMail?: boolean;
}

export function TabPanel({ activeTab, onTabChange, children, hideMail }: TabPanelProps) {
  return (
    <div className="space-y-4">
      <div className="flex gap-1 border-b border-border overflow-x-auto">
        {TABS.filter(tab => !hideMail || tab.id !== 'mail').map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={cn(
              "px-4 py-2 text-sm font-medium transition-colors relative",
              activeTab === tab.id
                ? "text-primary"
                : "text-muted-foreground hover:text-foreground"
            )}
          >
            {tab.label}
            {activeTab === tab.id && (
              <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-primary" />
            )}
          </button>
        ))}
      </div>
      {children}
    </div>
  );
}

interface SubTabPanelProps {
  tabs: { id: string; label: string }[];
  activeTab: string;
  onTabChange: (tab: string) => void;
}

export function SubTabPanel({ tabs, activeTab, onTabChange }: SubTabPanelProps) {
  return (
    <div className="flex gap-1 bg-muted/30 rounded-lg p-1">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onTabChange(tab.id)}
          className={cn(
            "px-3 py-1.5 text-xs font-medium rounded transition-colors",
            activeTab === tab.id
              ? "bg-card text-foreground shadow-sm"
              : "text-muted-foreground hover:text-foreground"
          )}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}
